const namespaceReferrals = '[Referrals]';

export const REFERRALS_GET_ALL = `${namespaceReferrals} REFERRALS GET ALL `;
